(function ($){

  // guide map
  if ($('#guide-map').length > 0) {

    var map
    var infoWindow
    var markers = []

    function initMap() {

      map = new google.maps.Map(document.getElementById("guide-map"), {
        zoom: 3,
        minZoom: 3,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControl: true,
        fullscreenControl: false,
        center: { lat: 40.743170, lng: -73.990850 },
      })

      // Set the bound manually
      var bounds = new google.maps.LatLngBounds({
        south: 40.7391691,
        west: -73.9931495,
        north: 40.747771,
        east: -73.9822309
      });
      map.fitBounds(bounds);

      var pixelOffset = Foundation.MediaQuery.current == 'small' ? new google.maps.Size(145, 250) : new google.maps.Size(150, 250)
      infoWindow = new google.maps.InfoWindow({
        pixelOffset: pixelOffset,
        content: ''
      })

      // shape
      var flatironCoordinates = [{lng:-73.982663,lat:40.740291},{lng:-73.983075,lat:40.739723},{lng:-73.983974,lat:40.7401},{lng:-73.984044,lat:40.740011},{lng:-73.984236,lat:40.739746},{lng:-73.983873,lat:40.73958},{lng:-73.983674,lat:40.739864},{lng:-73.983129,lat:40.739641},{lng:-73.983206,lat:40.739535},{lng:-73.98276,lat:40.739352},{lng:-73.983143,lat:40.73883},{lng:-73.98329,lat:40.738645},{lng:-73.983605,lat:40.738777},{lng:-73.983619,lat:40.738756},{lng:-73.983688,lat:40.738786},{lng:-73.983792,lat:40.738635},{lng:-73.98427,lat:40.738844},{lng:-73.984486,lat:40.738544},{lng:-73.986488,lat:40.739389},{lng:-73.986731,lat:40.73905},{lng:-73.986465,lat:40.738951},{lng:-73.986465,lat:40.738945},{lng:-73.986454,lat:40.73895},{lng:-73.986455,lat:40.738965},{lng:-73.986388,lat:40.738924},{lng:-73.986388,lat:40.738919},{lng:-73.98638,lat:40.73891},{lng:-73.986591,lat:40.738624},{lng:-73.986863,lat:40.738738},{lng:-73.987311,lat:40.73813},{lng:-73.987201,lat:40.738084},{lng:-73.987399,lat:40.737814},{lng:-73.987925,lat:40.738036},{lng:-73.987934,lat:40.738012},{lng:-73.988317,lat:40.738178},{lng:-73.988352,lat:40.738142},{lng:-73.988425,lat:40.738173},{lng:-73.988387,lat:40.738228},{lng:-73.989853,lat:40.738844},{lng:-73.989859,lat:40.738816},{lng:-73.990445,lat:40.739055},{lng:-73.990423,lat:40.739084},{lng:-73.990645,lat:40.739178},{lng:-73.990611,lat:40.73923},{lng:-73.991135,lat:40.739447},{lng:-73.991183,lat:40.73937},{lng:-73.991624,lat:40.73955},{lng:-73.991606,lat:40.739582},{lng:-73.992012,lat:40.739757},{lng:-73.992228,lat:40.739461},{lng:-73.99261,lat:40.73962},{lng:-73.992392,lat:40.739913},{lng:-73.99249,lat:40.739952},{lng:-73.992701,lat:40.739666},{lng:-73.992766,lat:40.739691},{lng:-73.992546,lat:40.739978},{lng:-73.992818,lat:40.740097},{lng:-73.993034,lat:40.739801},{lng:-73.993155,lat:40.739855},{lng:-73.992918,lat:40.740159},{lng:-73.993696,lat:40.74049},{lng:-73.993748,lat:40.740447},{lng:-73.994381,lat:40.740715},{lng:-73.994601,lat:40.740439},{lng:-73.995238,lat:40.740707},{lng:-73.995011,lat:40.740992},{lng:-73.994788,lat:40.741286},{lng:-73.99464,lat:40.741492},{lng:-73.994378,lat:40.741391},{lng:-73.994115,lat:40.741763},{lng:-73.994516,lat:40.741941},{lng:-73.993853,lat:40.742857},{lng:-73.993676,lat:40.742781},{lng:-73.993418,lat:40.743142},{lng:-73.993352,lat:40.74312},{lng:-73.992864,lat:40.743792},{lng:-73.992945,lat:40.743826},{lng:-73.992707,lat:40.744145},{lng:-73.992679,lat:40.744133},{lng:-73.992461,lat:40.744434},{lng:-73.992574,lat:40.744482},{lng:-73.992356,lat:40.744781},{lng:-73.992199,lat:40.744714},{lng:-73.991967,lat:40.745048},{lng:-73.991941,lat:40.745039},{lng:-73.991728,lat:40.745348},{lng:-73.991845,lat:40.745395},{lng:-73.991628,lat:40.745694},{lng:-73.991563,lat:40.745661},{lng:-73.991099,lat:40.746297},{lng:-73.991144,lat:40.746316},{lng:-73.990906,lat:40.746631},{lng:-73.991285,lat:40.746786},{lng:-73.991075,lat:40.74707},{lng:-73.990831,lat:40.746973},{lng:-73.990614,lat:40.747253},{lng:-73.990422,lat:40.747204},{lng:-73.990237,lat:40.747467},{lng:-73.99019,lat:40.747458},{lng:-73.990209,lat:40.747688},{lng:-73.990185,lat:40.747834},{lng:-73.990101,lat:40.747974},{lng:-73.989914,lat:40.748225},{lng:-73.989572,lat:40.74809},{lng:-73.987829,lat:40.747337},{lng:-73.987542,lat:40.747734},{lng:-73.987566,lat:40.747746},{lng:-73.987402,lat:40.747963},{lng:-73.987288,lat:40.747916},{lng:-73.987522,lat:40.747595},{lng:-73.98621,lat:40.74704},{lng:-73.986292,lat:40.74693},{lng:-73.985817,lat:40.746719},{lng:-73.985812,lat:40.746727},{lng:-73.985137,lat:40.746444},{lng:-73.984992,lat:40.74665},{lng:-73.985014,lat:40.74666},{lng:-73.98485,lat:40.746888},{lng:-73.984674,lat:40.746819},{lng:-73.984911,lat:40.746489},{lng:-73.984604,lat:40.746358},{lng:-73.984373,lat:40.746678},{lng:-73.984323,lat:40.746656},{lng:-73.984455,lat:40.746471},{lng:-73.984037,lat:40.746294},{lng:-73.984141,lat:40.74615},{lng:-73.983209,lat:40.745774},{lng:-73.983203,lat:40.745728},{lng:-73.982927,lat:40.745625},{lng:-73.982729,lat:40.745904},{lng:-73.982362,lat:40.745752},{lng:-73.981918,lat:40.746369},{lng:-73.981059,lat:40.746035},{lng:-73.98147,lat:40.74545},{lng:-73.981632,lat:40.745518},{lng:-73.98184,lat:40.745231},{lng:-73.982034,lat:40.745314},{lng:-73.982267,lat:40.744984},{lng:-73.982392,lat:40.745035},{lng:-73.982586,lat:40.744777},{lng:-73.982485,lat:40.744738},{lng:-73.982745,lat:40.744382},{lng:-73.982851,lat:40.744424},{lng:-73.983048,lat:40.744152},{lng:-73.982925,lat:40.7441},{lng:-73.982993,lat:40.743998},{lng:-73.983061,lat:40.744027},{lng:-73.983242,lat:40.743789},{lng:-73.983065,lat:40.743711},{lng:-73.983283,lat:40.743411},{lng:-73.983383,lat:40.743452},{lng:-73.98363,lat:40.743114},{lng:-73.983369,lat:40.743007},{lng:-73.98356,lat:40.742737},{lng:-73.983629,lat:40.742772},{lng:-73.98409,lat:40.742135},{lng:-73.984229,lat:40.742196},{lng:-73.984476,lat:40.74186},{lng:-73.983381,lat:40.741418},{lng:-73.983826,lat:40.74078},{lng:-73.982663,lat:40.740291}]
      var flatironPath = new google.maps.Polyline({
        path: flatironCoordinates,
        geodesic: true,
        strokeColor: "#000000",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      })

      var strX = ''
      var strY = ''
      for(var z=0;z<flatironCoordinates.length;z++) {
        strX += flatironCoordinates[z].lng+','
        strY += flatironCoordinates[z].lat+','
      }
      //console.log(strX)
      //console.log(strY)

      flatironPath.setMap(map)

      // set style
      var mapType = new google.maps.StyledMapType([ { "featureType": "water", "elementType": "geometry", "stylers": [ { "color": "#e9e9e9" }, { "lightness": 17 } ] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 20 } ] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [ { "color": "#ffffff" }, { "lightness": 17 } ] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [ { "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 } ] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 18 } ] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [ { "color": "#ffffff" }, { "lightness": 16 } ] }, { "featureType": "poi", "elementType": "geometry", "stylers": [ { "color": "#f5f5f5" }, { "lightness": 21 } ] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [ { "color": "#dedede" }, { "lightness": 21 } ] }, { "elementType": "labels.text.stroke", "stylers": [ { "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 } ] }, { "elementType": "labels.text.fill", "stylers": [ { "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 } ] }, { "elementType": "labels.icon", "stylers": [ { "visibility": "off" } ] }, { "featureType": "transit", "elementType": "geometry", "stylers": [ { "color": "#f2f2f2" }, { "lightness": 19 } ] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [ { "color": "#fefefe" }, { "lightness": 20 } ] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [ { "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 } ] } ])
      map.mapTypes.set('snazzyMapType', mapType)
      map.setMapTypeId('snazzyMapType')

      map.addListener('zoom_changed', function() {
        infoWindow.close()
      })
    }

    function addMarkers() {
      var bounds = new google.maps.LatLngBounds()
      var pixelOffset = Foundation.MediaQuery.current == 'small' ? new google.maps.Size(145, 250) : new google.maps.Size(150, 250)
      infoWindow = new google.maps.InfoWindow({
        pixelOffset: pixelOffset,
        content: ''
      })

      $('.businesses .business.match').each(function() {
        var $business = $(this)
        //console.log($business.data('title'))
        var data = {
          html: $business.html(),
          lat: $business.data('latitude'),
          lng: $business.data('longitude'),
          postId: $business.data('post-id'),
          mapMarkerUrl: $business.data('map-marker')
        }
        var latlng = new google.maps.LatLng(data.lat, data.lng )
        var marker = new google.maps.Marker({
          position: latlng,
          map: map,
          data: data
        })
        var icon = {
          url: data.mapMarkerUrl,
          scaledSize: new window.google.maps.Size(12, 12)
        }
        marker.setIcon(icon)
        marker.setOptions({
          zIndex: 1
        })
        bounds.extend(latlng)
        markers.push(marker)
      })

      $.each(markers, function(i, marker) {
        // click
        google.maps.event.addListener(marker, 'click', function() {
          // reset marker
          $.each(markers, function(i, marker) {
            marker.setOptions({
              zIndex: 1
            })
          })
          marker.setOptions({
            zIndex: 10
          })
          // infowindow
          var contentString = '<div id="infowindow-wrapper">' + marker.data.html + '</div>'
          infoWindow.setContent(contentString)
          infoWindow.open(map, marker)
        })
      })
      map.fitBounds(bounds)
    }

    function clearMarkers() {
      for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
      markers = [];
    }

    function closeInfowindow() {
      infoWindow.close()
    }

    function clearKeywordSearch() {
      $('#keyword-filter-desktop, #keyword-filter-mobile').val('')
    }

    function getBusinesses() {
      //console.log('getBusinesses()')
      var tids = []
      var parentTids = []
      var $match = null

      if (Foundation.MediaQuery.current == 'small') {
        var $parentTag = $('.cell-tags .parent-tags .tag.is-selected')
        if ($('.cell-tags .child-tags .tag.is-selected').length > 0) {
          $('.cell-tags .child-tags .tag.is-selected').each(function() {
            var $childTag = $(this)
            tids.push(parseInt($childTag.data('term-id')))
          })
        } else {
          if ($parentTag.length > 0) {
            parentTids.push(parseInt($parentTag.data('term-id')))
            tids.push(parseInt($parentTag.data('term-id')))
          }
        }
        //console.log(parentTids)
        //console.log(tids)
      } else {

        if ($('.filters-drilldown ul.nested.is-active').length > 0) {
          parentTids.push(parseInt($('.filters-drilldown li[aria-expanded="true"]').data('term-id')))
          //console.log('just parent')
        }
        if ($('.filters-drilldown input[type="checkbox"]:checked').length > 0) {
          $('.filters-drilldown input[type="checkbox"]:checked').each(function() {
            tids.push(parseInt($(this).attr('value')))
          })
          //console.log('has checkboxes checked!')
        } else {
          if ($('.filters-drilldown ul.nested.is-active').length > 0) {
            tids.push(parseInt($('.filters-drilldown li[aria-expanded="true"]').data('term-id')))
            //console.log('just parent')
          } else {
            parentTids = []
            tids = []
            //console.log('nothing')
          }
        }
      }

      $('.filters-drilldown .js-drilldown-back a span').html($('.filters-drilldown li[aria-expanded="true"]').data('term-name'))

      var url = '';
      if (tids.length > 0 || parentTids > 0) {
        url += '?ajax=1'
      }
      if (tids.length > 0) {
        for (var i=0; i < tids.length; ++i) {
          url += '&tids[]=' + tids[i]
        }
      }
      if (parentTids.length > 0) {
        for (var i=0; i < parentTids.length; ++i) {
          url += '&parent-tids[]=' + parentTids[i]
        }
      }
      //console.log(url)
      //url = window.location.pathname + url
      //history.pushState(null, null, url)

      if (tids.length == 0) {
        $('.businesses .business').addClass('hide').addClass('match')
      } else {
        $('.businesses .business').addClass('hide').removeClass('match').each(function() {
          var $business = $(this)
          var businessTids = $business.data('term-ids').split(',')
          var match = false
          $.each(businessTids, function(index, value) {
            var tid = parseInt(value)
            if ($.inArray(tid, tids) > -1) {
              $business.addClass('match')
            }
          })
        })
      }

      // keyword search
      var autocompleteVal = Foundation.MediaQuery.current == 'small' ? $('#keyword-filter-mobile').val() : $('#keyword-filter-desktop').val()
      if (autocompleteVal) {
        var $match = $('.businesses .business[data-title-address="' + autocompleteVal + '"]')
        if ($match && $match.length > 0) {
          $('.businesses .business').addClass('hide').removeClass('match')
          $match.addClass('match')
        }
      }

      // update search results count
      $('.filters-drilldown .js-drilldown-back em').html($('.block-guide-map .businesses .business.match').length + ' Results')

      // control more
      $('.businesses-container .more').addClass('hide')
      $('.businesses').find('.cell.hide.match').slice(0, 24).removeClass('hide');
      if ($('.businesses').find('.cell.hide.match').length > 0) {
        $('.businesses-container .more').removeClass('hide')
      }

      // update map
      closeInfowindow()
      clearMarkers()
      addMarkers()

      // default match
      if ($match && $match.length > 0) {
        var matchPostId = $match.data('post-id')
        $.each(markers, function(i, marker) {
          if (marker.data.postId == matchPostId) {
            google.maps.event.trigger(marker, 'click');
          }
        })
      }

    }

    // Wait for Google Maps API to be available
    function waitForGoogleMaps(callback) {
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        callback();
      } else {
        var checkInterval = setInterval(function() {
          if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
            clearInterval(checkInterval);
            callback();
          }
        }, 100); // Check every 100ms
        
        // Timeout after 10 seconds to prevent infinite waiting
        setTimeout(function() {
          clearInterval(checkInterval);
          console.error('Google Maps API failed to load within 10 seconds');
        }, 10000);
      }
    }

    // Fetch business data
    waitForGoogleMaps(function() {
      initMap()
      clearKeywordSearch()

      $.ajax({
        url: window.flatiron_config.ajaxurl,
        data: {
          action: 'fetch_business',
        }
      })
        .then(function (res) {
          $('.block-guide-map__loading').fadeOut(250);
          $('.business-list').html(res);
          addMarkers();
          $('body').trigger('business-fetched');
        });

      // addMarkers()
    })

    $('#keyword-filter-desktop').on('change', function(e) {
      e.stopPropagation()
    })

    $('.filters-drilldown').on('open.zf.drilldown', function(e) {
      //console.log('open.zf.drilldown')
      setTimeout(function() {
        if ($(e.target).attr('id') != 'keyword-filter-desktop') {
          clearKeywordSearch()
          getBusinesses()
        }
      }, 550)
    })

    $('.filters-drilldown').on('hide.zf.drilldown', function() {
      //console.log('hide.zf.drilldown - unchecking all checkboxes')
      $('.filters-drilldown input[type="checkbox"]').prop('checked', false)
      setTimeout(function() {
        clearKeywordSearch()
        getBusinesses()
      }, 550)
    })

    $('.filters-drilldown input[type="checkbox"]').on('click', function() {
      clearKeywordSearch()
      getBusinesses()
    })

    $('.view-toggle-map').on('click', function(e) {
      $('.block-guide-map').addClass('view-mode--is-map')
      $('.view-toggle-map').addClass('is-active')
      $('.view-toggle-grid').removeClass('is-active')
      e.preventDefault()
    })

    $('.view-toggle-grid').on('click', function(e) {
      $('.block-guide-map').removeClass('view-mode--is-map')
      $('.view-toggle-map').removeClass('is-active')
      $('.view-toggle-grid').addClass('is-active')
      e.preventDefault()
    })

    $('.cell-bar').on('click', function(e) {
      $('.block-guide-map').toggleClass('view-mode--expanded-map')
    })

    $('body').on('click', '.businesses-container .more', function(e) {
      $('.businesses').find('.cell.hide.match').slice(0, 24).removeClass('hide');
      if ($('.businesses').find('.cell.hide.match').length == 0) {
        $(this).remove();
      }
      e.preventDefault()
    })

    // infowindow - close slideshow
    $('body').on('click', '.infowindow-content-images .close', function(e) {
      closeInfowindow()
      e.preventDefault()
    })

    // infowindow - next image
    $('body').on('click', '.infowindow-content-images .next', function(e) {
      var $images = $(this).closest('.infowindow-content-images')
      var index = $images.find('.image.is-showing').index()
      var total = $images.find('.image').length
      var nextIndex = index + 1
      if (nextIndex >= total) {
        nextIndex = 0
      }
      var $image = $images.find('.image').eq(nextIndex)
      if ($image.data('image-url')) {
        $image.css('backgroundImage', 'url(' + $image.data('image-url') + ')')
        $image.removeAttr('image-url')
      }
      $images.find('.image').removeClass('is-showing')
      $image.addClass('is-showing')
      e.preventDefault()
    })

    // infowindow - previous image
    $('body').on('click', '.infowindow-content-images .previous', function(e) {
      var $images = $(this).closest('.infowindow-content-images')
      var index = $images.find('.image.is-showing').index()
      var total = $images.find('.image').length
      var nextIndex = index - 1
      if (nextIndex < 0) {
        nextIndex = total - 1
      }
      var $image = $images.find('.image').eq(nextIndex)
      if ($image.data('image-url')) {
        $image.css('backgroundImage', 'url(' + $image.data('image-url') + ')')
        $image.removeAttr('image-url')
      }
      $images.find('.image').removeClass('is-showing')
      $image.addClass('is-showing')
      e.preventDefault()
    })

    // mobile tags
    $('.cell-tags .parent-tags a').on('click', function(e) {
      var $a = $(this)
      var index = $a.index()
      $('.cell-tags .parent-tags a, .cell-tags .child-tags a').removeClass('is-selected')
      $a.addClass('is-selected')
      $('.cell-tags .child-tags').addClass('hide').eq(index).removeClass('hide')
      clearKeywordSearch()
      getBusinesses()
      e.preventDefault()
    })
    $('.cell-tags .child-tags a').on('click', function(e) {
      var $a = $(this)
      $a.toggleClass('is-selected')
      clearKeywordSearch()
      getBusinesses()
      e.preventDefault()
    })

    // Initiate autocomplete after business data fetched
    $('body').on('business-fetched', function() {
      if ($('#keyword-filter-desktop').length > 0) {
        var autoCompleteConfig = {
          selector: Foundation.MediaQuery.current == 'small' ? '#keyword-filter-mobile' : '#keyword-filter-desktop',
          placeHolder: '',
          data: {
            src: [],
            cache: true,
          },
          resultsList: {
            maxResults: 20
          },
          resultItem: {
            highlight: true
          },
          events: {
            focus: () => {
              if (autoCompleteJS.input.value.length) autoCompleteJS.start()
            },
            input: {
              selection: (event) => {
                var selection = event.detail.selection.value
                autoCompleteJS.input.value = selection
                if ($('.businesses .business[data-title-address="' + selection + '"]').length > 0) {
                  //console.log('ff')
                  getBusinesses()
                }
              }
            }
          }
        }
  
        $('.businesses .business').each(function() {
          var $business = $(this)
          var choice = $business.data('title-address')
          autoCompleteConfig.data.src.push(choice)
        })
  
        var autoCompleteJS = new autoComplete( autoCompleteConfig )
      }
    })

  }

})(jQuery);